// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/font/CentraNo2-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/font/CentraNo2-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/font/CentraNo2-Book.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Copyright 2025 Jiaqi Liu. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans",
    "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

@font-face {
  font-family: Centra;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-weight: 700;
}
@font-face {
  font-family: Centra;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-weight: 500;
}
@font-face {
  font-family: Centra;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-weight: 400;
}

:root {
  --red: #e4562d;
  --dark-red: #d92c0d;
  --cyan: #53dac2;
  --blue: #407fbb;
  --dark-blue: #1c5dab;
  --green: #86be73;
  --dark-green: #44945d;
  --yellow: #f9edb8;
  --dark-yellow: #c9ab63;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
  scroll-padding-top: 75px;
}

body {
  font-weight: 400;
  overflow-x: hidden;
  position: relative;
  background-color: #121212 !important;
  color: #fff !important;
  font-family: "Centra", sans-serif !important;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  padding: 0;
  line-height: normal;
}

p,
a,
li,
button,
ul {
  margin: 0;
  padding: 0;
  line-height: normal;
  text-decoration: none;
}

a:hover {
  text-decoration: none;
}

img {
  width: 100%;
  height: auto;
}

button {
  border: 0;
  background-color: transparent;
}

input:focus,
textarea:focus,
select:focus {
  outline: none;
}

@media (min-width: 1700px) {
  main .container {
    max-width: 100%;
    padding: 0 150px;
  }
}

p.success {
  color: green;
}

p.danger {
  color: red;
}
`, "",{"version":3,"sources":["webpack://./packages/studytour-io-app/src/index.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;EAcE;AACF;EACE,SAAS;EACT;8CAC4C;EAC5C,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,+EAA+E;AACjF;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;EAC5C,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,4CAA8C;EAC9C,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,oCAAoC;EACpC,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;;;;;;EAME,SAAS;EACT,UAAU;EACV,mBAAmB;AACrB;;AAEA;;;;;EAKE,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,6BAA6B;AAC/B;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ","sourcesContent":["/**\n * Copyright 2025 Jiaqi Liu. All rights reserved.\n *\n * Licensed under the Apache License, Version 2.0 (the \"License\");\n * you may not use this file except in compliance with the License.\n * You may obtain a copy of the License at\n *\n *     http://www.apache.org/licenses/LICENSE-2.0\n *\n * Unless required by applicable law or agreed to in writing, software\n * distributed under the License is distributed on an \"AS IS\" BASIS,\n * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\n * See the License for the specific language governing permissions and\n * limitations under the License.\n */\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\",\n    \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\", monospace;\n}\n\n@font-face {\n  font-family: Centra;\n  src: url(\"./assets/font/CentraNo2-Bold.ttf\");\n  font-weight: 700;\n}\n@font-face {\n  font-family: Centra;\n  src: url(\"./assets/font/CentraNo2-Medium.ttf\");\n  font-weight: 500;\n}\n@font-face {\n  font-family: Centra;\n  src: url(\"./assets/font/CentraNo2-Book.ttf\");\n  font-weight: 400;\n}\n\n:root {\n  --red: #e4562d;\n  --dark-red: #d92c0d;\n  --cyan: #53dac2;\n  --blue: #407fbb;\n  --dark-blue: #1c5dab;\n  --green: #86be73;\n  --dark-green: #44945d;\n  --yellow: #f9edb8;\n  --dark-yellow: #c9ab63;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml {\n  scroll-behavior: smooth;\n  scroll-padding-top: 75px;\n}\n\nbody {\n  font-weight: 400;\n  overflow-x: hidden;\n  position: relative;\n  background-color: #121212 !important;\n  color: #fff !important;\n  font-family: \"Centra\", sans-serif !important;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin: 0;\n  padding: 0;\n  line-height: normal;\n}\n\np,\na,\nli,\nbutton,\nul {\n  margin: 0;\n  padding: 0;\n  line-height: normal;\n  text-decoration: none;\n}\n\na:hover {\n  text-decoration: none;\n}\n\nimg {\n  width: 100%;\n  height: auto;\n}\n\nbutton {\n  border: 0;\n  background-color: transparent;\n}\n\ninput:focus,\ntextarea:focus,\nselect:focus {\n  outline: none;\n}\n\n@media (min-width: 1700px) {\n  main .container {\n    max-width: 100%;\n    padding: 0 150px;\n  }\n}\n\np.success {\n  color: green;\n}\n\np.danger {\n  color: red;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
